'use client'

import { useEffect, useRef } from 'react'

interface UseCartIsOpenProps {
  isCartOpen: boolean
  onCartOpen: () => void
}

export const useOnCartOpen = ({ isCartOpen, onCartOpen }: UseCartIsOpenProps) => {
  const prevCartOpenState = useRef<boolean>(false)

  useEffect(() => {
    if (isCartOpen && !prevCartOpenState.current) {
      onCartOpen()
    }
    prevCartOpenState.current = isCartOpen
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Do not add "onCartOpen" to dependencies"
  }, [isCartOpen])
}
